import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import _ from 'lodash';

function capitalizeFirstLetter(value) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export function createVariations(baseName, nameSuffixes, key, value) {
  return _.reduce(nameSuffixes, function (result, variant) {
    var variantName = variant ? baseName + "-" + variant : baseName;
    var keyName = variant ? "" + key + capitalizeFirstLetter(variant) : key;
    result[variantName] = _defineProperty({}, keyName, value);
    return result;
  }, {});
}
export function createSharedStyle(componentNames) {
  var sharedStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var customStyles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return _.reduce(componentNames, function (result, componentName) {
    result[componentName] = _objectSpread({}, sharedStyle, {}, customStyles[componentName]);
    return result;
  }, {});
}